import { OktaAuth } from '@okta/okta-auth-js';
import config from './config';

// Single OktaAuth instance shared across the app. Exported so non-component
// code (e.g. axios interceptors that force logout on 401) can call signOut
// the same way the Header logout button does.
export const oktaAuth = new OktaAuth(config.okta);
